import data from 'emoji-mart-vue-fast/data/apple.json';
import { EmojiIndex } from 'emoji-mart-vue-fast/src';

EmojiIndex.prototype.tryEmoji = function (emoji: string, skin?: number) {
    try {
        return this.findEmoji(emoji, skin);
    } catch {
        return null;
    }
};

export const emojiIndex = new EmojiIndex(data);
